import { AssignKioskRepository } from '../data/assign-kiosk-repository';
import { KioskLocation } from '../types/assign-kiosk-types';

export interface GetKioskLocationsResult {
  locations: KioskLocation[];
  hasError: boolean;
  errorMessage?: string;
}

export class GetKioskLocationsUseCase {
  constructor(private readonly repository: AssignKioskRepository) {}

  async execute(
    operatorId: string | null,
    machineId: string | null,
    savedSettings: string | null = null,
    locationId?: string
  ): Promise<GetKioskLocationsResult> {
    try {
      const locations = await this.repository.getLocations(operatorId, machineId, savedSettings, locationId);
      return { locations, hasError: false };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to load locations';
      return { locations: [], hasError: true, errorMessage };
    }
  }
}
